import type { Role } from "../api/types";

export interface Tab {
  label: string;
  path: string;
  /** Roles that see this tab (BUILD_PLAN.md section 6.2). */
  roles: readonly Role[];
}

/** The header tabs, in order (section 11.0). */
export const TABS: readonly Tab[] = [
  { label: "Today", path: "/", roles: ["tech", "owner"] },
  { label: "Team", path: "/team", roles: ["owner"] },
  // A tech's are of their own work (section 6.2; ADR 0123).
  { label: "Reports", path: "/reports", roles: ["tech", "owner"] },
  { label: "Mappings", path: "/mappings", roles: ["owner"] },
  { label: "Health", path: "/health", roles: ["owner"] },
  // Every owner setting without a place on Mappings, and each person's time
  // zone and hours (the owner, 2026-10-19; ADR 0172).
  { label: "Settings", path: "/settings", roles: ["owner"] },
];

export function tabsFor(role: Role): Tab[] {
  return TABS.filter((tab) => tab.roles.includes(role));
}
